import { useDataQuery } from "hooks/useData";
import React, { useCallback, useMemo } from "react";

type SphereEditProps = {
  value: number | null;
  onChange: (v: number | null) => void;
};

const SphereEdit: React.FC<SphereEditProps> = ({ value, onChange }) => {
  const spheres = useDataQuery("spheres");

  const sphereList = useMemo(() => {
    if (!spheres) return [];

    return [...spheres, { id: 0, title: "Без сферы" }];
  }, [spheres]);

  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLSelectElement>) => {
      const v = event.target.value;
      onChange(v === "0" ? null : Number(v) || null);
    },
    [onChange],
  );

  if (!spheres || spheres.length === 0) return null;

  return (
    <div style={{ margin: "4px 0 8px" }}>
      <select
        id="sphere-select"
        value={value || "0"}
        onChange={handleChange}
        style={{ padding: "5px", fontSize: "14px", width: "100%" }}
      >
        <option value="0">{value ? "Сбросить" : "Выбрать сферу"}</option>
        {sphereList.map((s: { id: string; title: string }) => (
          <option
            key={s.id}
            value={s.id}
          >
            {s.title}
          </option>
        ))}
      </select>
    </div>
  );
};

export default SphereEdit;
